import React, { useEffect, useState } from "react";
import imb_portfolio_balance from "../../../assets/images/upcoming-payments.png";
import { DefaultCards, DefaultSection } from ".";
import { useDispatch, useSelector } from "react-redux";
import { loadingTypes } from "../../../Utils/constant";
import { fetchBorrowerPastDue31Days } from "../../../store/reducers/dashboardSlice/api";
import useBorrowerDashboardTwo from "./apis/useBorrowerDashboardTwo";
import { PortfolioLoansModal } from "./AccountSummary";
import VisualRepresentation from "./VisualRepresentation";
import { gridColumns_DefaultManagement31DaysPast } from "../../../Utils/TableColumnDefs";
import TicketCard from "./TicketCard";

function UpComingPayment({ isRoc }) {
  const [show, setShow] = useState(false);
  const data = useSelector(
    (state) => state.dashboard.borrowerPastDue31DaysLoans.data
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerPastDue31DaysLoans.status
  );
  const { activeAccountList } = useBorrowerDashboardTwo();
  const dispatch = useDispatch();

  useEffect(() => {
    if (status === loadingTypes.idle && activeAccountList?.length) {
      dispatch(
        fetchBorrowerPastDue31Days({
          requestBody: {
            borrowerRecID: activeAccountList?.map((el) => el.value).join(" "),
          },
        })
      );
    }
  }, [status, dispatch, activeAccountList?.length]);

  // const calculatePrincipalBalanceSum = (data) => {
  //   return data.reduce(
  //     (sum, loan) => sum + (loan["Principal Balance"] || "-"),
  //     0
  //   );
  // };

  // const principalBalanceSum = calculatePrincipalBalanceSum(data);

  return (
    <div className="h-100 d-flex flex-column gap-3 bottomInsights">
      {isRoc ? <VisualRepresentation /> : <DefaultSection />}

      {!isRoc ? (
        <DefaultCards
          title={"31+ Days Past Due Defaults"}
          value={
            status === loadingTypes.fulfilled
              ? data.length
              : status === loadingTypes.loading
              ? "-"
              : 0
          }
          prefix={""}
          decimalScale={0}
          onClick={() => setShow((prev) => !prev)}
          role={"button"}
          // h100={true}
          className="clickable-card"
        />
      ) : null}
      <TicketCard />

      <PortfolioLoansModal
        show={show}
        setShow={setShow}
        data={data}
        status={status}
        title={"31+ Days Past Due Defaults"}
        gridColumns={gridColumns_DefaultManagement31DaysPast}
      />
    </div>
  );
}

export default UpComingPayment;

{
  /* <h6 className="mb-3">Upcoming Payments</h6>

        <div className="d-flex flex-column flex-grow-1 border-top">
          <ul className="list-group list-group-flush d-flex flex-column flex-grow-1">
            {[
              {
                date: "2/19/2025",
                to: "002659853",
                amount: "$25,650.12",
              },
              {
                date: "2/28/2025",
                to: "005698762",
                amount: "$6,725.12",
              },
              {
                date: "3/10/2025",
                to: "002369587",
                amount: "$18,264.13",
              },
            ].map((item, index, arr) => (
              <li
                key={index}
                className={`list-group-item d-flex justify-content-between align-items-center py-3 flex-grow-1 border-bottom`}
              >
                <div className="d-flex flex-column">
                  <span className="small fw-bold">{item.date}</span>
                  <span className="small text-muted">To: {item.to}</span>
                </div>
                <span className="fw-bold text-primary">{item.amount}</span>
              </li>
            ))}
          </ul>
        </div>

       
        <div className="mt-auto text-start">
          <Button
            variant="link"
            className="p-0 text-primary small"
            style={{ textDecoration: "none" }}
          >
            View All
          </Button>
        </div> */
}
